




































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

import { Producer } from '@/modules/Producer/interfaces/producer'
import { translateProducerTypeKey } from '@/utils/translate'
import AppDialog from '@/components/AppDialog.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'
import { formatPhoneNumber } from '@/utils/phoneNumberFormat'
import dollarFilter from '@/utils/dollarFilter'

@Component({
  components: {
    FoldingCard,
    AppDialog,
    AppSystemInfoCard
  }
})
export default class ProducerDetailDetail extends Vue {
  @Prop({ type: Object as () => Producer }) readonly producer!: Producer

  translateProducerTypeKey = (key: string) => translateProducerTypeKey(key)
  formatPhoneNumber = formatPhoneNumber

  commissionCard = [
    { title: 'New Business Commission Split', content: '-' },
    { title: 'Renewal Commission Split', content: '-' }
  ]

  dollarFilter = dollarFilter

  @Watch('producer', { deep: true })
  onProducerUpdated (val: Producer) {
    this.commissionCard[0].content = val.newBusinessCommissionSplit || '-'
    this.commissionCard[1].content = val.renewalCommissionSplit || '-'
  }

  get subCodes () {
    if (!this.producer || !this.producer.producerSubCode) return []
    return this.producer.producerSubCode.split('\n')
  }

  mounted () {
    this.onProducerUpdated(this.producer)
  }
}
